import { Dispatch } from 'redux'
import { CampaignAction, CampaignState } from './types'
import { useDispatch, useSelector } from 'react-redux'
import { ApplicationState } from '../store'

type UseCampaign = {
  campaignState: CampaignState
  campaignDispatch?: Dispatch<CampaignAction>
}

export const useCampaign = (): UseCampaign => {
  const campaignState = useSelector<ApplicationState, CampaignState>(rootReducer => rootReducer.campaignReducer)
  const campaignDispatch = useDispatch<Dispatch<CampaignAction>>()
  return { campaignState, campaignDispatch }
}
